export const ugovor_o_radu_direktora= {
    templateId: 225,
    category: 15,
    templateTitle: "Ugovor o radu direktora (ugovor radnog prava)",
    templateDescription: `<p>Ukoliko se član uprave (direktor) nalazi i u radnom odnosu kod poslodavca, na takav odnos se ne primjenjuju sve odredbe Zakona o radu, a dodatno se može ugovoriti i samostalnost u određivanju radnog vremena.</p>`,
    description: `
      <h5>OPIS I SVRHA DOKUMENTA</h5>
      <p>Osoba koja je pojedinačno i samostalno ili zajedno i skupno, ovlaštena voditi poslove poslodavca (član uprave ili izvršni direktor odnosno fizička osoba koja je u drugom svojstvu prema posebnom zakonu), može i kao radnik u radnom odnosu, točnije direktor u svojstvu radnika, obavljati određene poslove za poslodavca.</p>
      <p>Navedene osobe smatraju se radnikom u statusu rukovodeće osobe te se na njih ne primjenjuju se dredbe Zakona o radu koje se odnose na ugovore o radu na određeno vrijeme, prestanak ugovora o radu, otkazne rokove i otpremninu.</p>
      <p>Na radnika koji ima status rukovodeće osobe ne primjenjuju se niti odredbe Zakona o radu o najdužem trajanju tjednog radnog vremena i razdoblju nejednakog rasporeda radnog vremena, noćnom radu, te dnevnom i tjednom odmoru, ako su s poslodavcem ugovorili samostalnost u njihovu određivanju.</p>
      <p>Pod rukovodećim osobljem smatra se radnik koji je ovlašten voditi poslove poslodavca, samostalno zaključivati pravne poslove u ime i za račun poslodavca, kojem raspored radnog vremena nije moguće unaprijed odrediti i koji o tom rasporedu samostalno odlučuje.</p>
      <p>Predloškom ugovora u nastavku uređuju se osnovne odredbe ugovora o radu između poslodavca i direktora, bez posebnih odredbi o dodatnim pravima i obvezama kojima bi se direktor smatrao ustvari i manedžerom.</p>
   
      <p>Predložak ugovora o radu rukovodeće osobe kao menadžera koji sadržava odredbe o dodatnim pravima i obvezema možete pogledati <a class="local-link" href="/contract?template=223">ovdje</a>.</p>

      <h5>PRAVNA OSNOVA</h5>
      <p>Zakon o radu.</p>
    `,
  
    sides: [
      {
        signature: "Za Poslodavca:",
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Poslovni subjekt",
        },
        {
          type: "input",
          required: true,
          placeholder: "Ulica i kućni broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "Mjesto",
        },
        {
          type: "input",
          required: true,
          placeholder: "OIB",
        },
        {
          type: "input",
          placeholder: "Zastupa",
          inSignature: true,
        },
        {
          type: "input",
          placeholder: "Funkcija",
          inSignature: true,
        }],
        suffix: " (u daljnjem tekstu: Poslodavac, Društvo),",
        delimiter: `i`
      },
      {
        signature: "Radnik:",
        inputs: [{
          type: "input",
          required: true,
          placeholder: "Ime i prezime",
          inSignature: true,
        },
        {
          type: "input",
          required: true,
          placeholder: "Ulica i kućni broj",
        },
        {
          type: "input",
          required: true,
          placeholder: "Mjesto",
        },
        {
          type: "input",
          required: true,
          placeholder: "OIB",
        },
        ],
        suffix: " (u daljnjem tekstu: Direktor),"
      }
    ],
  
    headline: "zaključuju sljedeći",
    title: "UGOVOR O RADU DIREKTORA",
  
    articles: [
      
        {
          title: 'UVODNE ODREDBE',
          mandatory: false,
          exampleContent: true, 
          statements: [
              {
                  type: 'text',
                  mandatory: true,
                  editable: true,
                  content: 'Ugovorne strane uvodno utvrđuju da je Direktor imenovan Odlukom o imenovanju na mjesto člana uprave Društva (u daljnjem tekstu: Odluka).',
              },
          ],
      },
  
    {
      title: "TRAJANJE UGOVORA",
      mandatory: true,
      exampleContent: true,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: true,
          choices: [
            "Na temelju ovog Ugovora o radu zasniva se radni odnos između Poslodavca i Direktora na određeno vrijeme, u periodu naznačenom Odlukom iz ovog Ugovora odnosno u trajanju od ________, točnije do __________.",
            "Na temelju ovog Ugovora o radu zasniva se radni odnos između Poslodavca i Direktora na neodređeno vrijeme."
          ],
          placeholder: "Odaberite ovdje te potom izmijenite po želji...",
          help: 'Na odnos poslodavca i direktora koji ujedno je i ovlašten za zastupanje društva, ne primjenjuju se odredbe Zakona o radu koje reguliraju prestanak ugovora o radu, (ali i o radu na određeno vrijeme, otkaznom roku i otpremnini), nego odredbe Zakona o obveznim odnosima, stoga se ugovor može sklopiti na određeno vrijeme bez navođenja objektivnog razloga.'
        }]
    },
    {
      title: 'POČETAK RADA',
      mandatory: true,
      statements: [
          {
              type: 'input',
              mandatory: true,
              editable: false,
              parts: [
                  {
                      type: 'text',
                      content: 'Direktor započinje s radom kod Poslodavca dana'
                  },
                  {type: 'input', value: '', required: true,},
                  {type: 'text', content: ' godine​.'},
                  ],
          }],
  },
{
  title: 'RADNO MJESTO',
  mandatory: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Direktor će obavljati sve poslove i zadatke na radnom mjestu: član uprave Društva.\r\nOsim toga, u obavljanju svojih poslova iz ovog Ugovora, Direktor će ispunjavati sve dužnosti utvrđene Zakonom o trgovačkim društvima i drugim propisima, osnivačkim aktom društva, Poslovnikom o radu uprave Društva i ovim Ugovorom. \r\nPoslodavac i Direktor suglasno utvrđuju kako je Direktor prije sklapanja ovog Ugovora upoznat sa sadržajem Pravilnika o radu Poslodavca te svim drugim općim aktima Poslodavca i  propisima u vezi s radnim odnosima, odlukama koje reguliraju poslovanje te da ga je Poslodavac upoznao s organizacijom rada, sistematizacijom i opisom radnih mjesta, platnim razredima i zaštitom zdravlja i sigurnosti na radu kao i da je od Poslodavca primio Priručnik zaštite na radu u svrhu upoznavanja s opasnostima u procesu rada.          ',
          value: '',
      }],
},
{
  title: 'MJESTO RADA',
  mandatory: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Direktor će obavljati poslove i zadatke u poslovnim prostorijama Društva, odnosno u drugim objektima Društva na teritoriju Republike Hrvatske.',
          value: '',
      }],
},
{
  title: 'RADNO VRIJEME, ODMORI I DOPUSTI',
  mandatory: true,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Imajući u vidu sadržaj i opseg navedenih dužnosti i ovlasti radnog mjesta, Direktor se smatra osobom od povjerenja koja samostalno organizira svoj rad i koja je izuzeta iz standarda općega radnog zakonodavstva i organizacijskih propisa Društva u vezi s trajanjem radnog dana i dnevnih normativa rada, ali minimalno pridržavajući se sljedećih uvjeta: \r\n- Direktor je obvezan na radnom mjestu raditi puno radno vrijeme od 40 sati tjedno, pet dana u tjednu, u koje je uključen dnevni odmor od 30 minuta dnevno, \r\n- Direktor se osim rada u tijeku radnog vremena iz prethodne točke ovog stavka obvezuje biti dostupan ostalim članovima Skupštine Društva u svako doba, u smislu pružanja informacija važnih za poslovanje Društva, \r\n- Direktor će tjedni odmor koristiti subotom i nedjeljom, \r\n- Direktor ima pravo koristiti godišnji odmor u trajanju od 30 radnih dana u kalendarskoj godini, no kod korištenja godišnjeg odmora u dijelovima, svakako će se pridržavati svih odredbi Zakona o radu koji regulira korištenja godišnjeg odmora u dijelovima.  \r\nU slučaju da Direktor ne koristi u cijelosti svoje pravo na godišnji odmor, preostali broj dana može iskoristiti u sljedećoj godini, sukladno pozitivnim propisima, a iznimno, ako Društvo o tome donese odluku, ima pravo i na naknadu štete za eventualne neiskorištene dane godišnjeg odmora. \r\nSukladno navedenom, Direktor neće primati posebne naknade za otežane uvjete rada, prekovremeni rad, rad nedjeljom ili blagdanima te se za trajanja mandata obvezuje sve svoje radne sposobnosti i raspoloživo vrijeme staviti u službu najboljih interesa Društva, uključujući i obvezu da, po potrebi, obavlja i druge rukovodeće poslove i zadatke unutar Društva i povezanih društava.          ',
          value: '',
      }],
},
{
  title: "PLAĆA",
  mandatory: true,
  statements: [
    {
      type: "input",
      mandatory: true,
      editable: false,
      parts: [
        { type: "text", content: "Za obavljanje poslova iz ovog Ugovora, Poslodavac će Radniku isplaćivati osnovnu plaću u iznosu od najmanje" },
        { type: "input", value: "", required: true },
        { type: "text", content: "kuna bruto.",  }],

    }
  ]
},
{
  title: "RAZDOBLJE ISPLATE PLAĆE",
  mandatory: true,
  statements: [
    {
      type: "choice",
      mandatory: true,
      editable: false,
      choices: [
        {
          parts: [
            { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Direktor ima pravo, jednom mjesečno i to najkasnije do zadnjeg dana tekućeg mjeseca za prethodni mjesec." },
          ]
        },
        {
          parts: [
            { type: "text", content: "Poslodavac će isplaćivati plaću te eventualna ostala primanja na koja Direktor ima pravo, jednom mjesečno i to najkasnije do " },
            { type: "input", value: "", required: true },
            { type: "text", content: "–og dana u mjesecu za prethodni mjesec." },
          ]
        }],
      value: "",
    }
  ]
},
{
  title: 'OTKAZ UGOVORA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'S obzirom da je Direktor član uprave odnosno osoba koja je prema Zakonu o trgovačkih društvima ovlaštena pojedinačno i samostalno ili zajedno i skupno ovlaštena voditi poslove Poslodavca, a ujedno i radnik u radnom odnosu kod Poslodavca na temelju ovog Ugovora, na ovaj ugovorni odnos se ne primjenjuju odredbe Zakona o radu koje se odnose na prestanak ugovora o radu. \r\nSvaka ugovorna strana može otkazati ovaj Ugovor iz bilo kojeg razloga i bez obrazloženja, pisanom obavijesti drugoj ugovornoj strani uz otkazni rok od 60 (šezdeset) dana. \r\nNa temelju sporazuma ugovornih strana Direktor može biti raspoređen na koje drugo radno mjesto u Društvu uz uvjete predviđene aktima Društva za takvo radno mjesto. \r\nU tom slučaju stranke će posebnim ugovorom iznova urediti svoje međusobne odnose.',
          value: '',
      }],
},
{
  title: 'OTPREMNINA',
  mandatory: false,
  statements: [
      {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'U slučaju otkaza ovog Ugovora od strane Društva, Društvo će Direktoru isplatiti otpremninu u visini 3 (tri) osnovne mjesečne  plaće, u roku od 30 dana od dana prestanka obavljanja funkcije osobe ovlaštena za zastupanje Društva. \r\nDirektor neće imati pravo na otpremninu u sljedećim slučajevima: \r\n- ako prijeđe na drugu funkciju i/ili radno mjesto u okviru Društva, njegovih podružnica, društava s kojima je Društvo povezano ili drugih organizacija nad kojima Društvo ima kontrolu, \r\n- ako do prestanka radnog odnosa, odnosno otkaza ovog Ugovora dođe zbog  povrede radne dužnosti, nanošenja znatne štete Društvu i/ili kršenja zakonskih propisa i/ili akata Društva od strane Direktora, te zbog drugih činidaba i/ili propusta Direktora koje Društvu nanose štetu, a rezultat su njegove namjere ili grube nepažnje, \r\n- ako do otkaza ovog Ugovora i/ili prekida radnog odnosa dođe iz razloga kršenja odredbi o zabrani konkurencije, poslovne tajne i ugovorne zabrane utakmice, \r\n- ako do otkaza ovog Ugovora i/ili radnog odnosa s Društvom dođe iz bilo kojeg razloga prije isteka 10  (deset) mjeseci od dana stupanja ovog Ugovora na snagu, s time da u razdoblje od navedenih 10 (deset) mjeseci ne ulazi vrijeme koje je Direktor proveo na bolovanju, plaćenom ili neplaćenom dopustu, \r\n- ako su obje ugovorne strane s time suglasne.',
          value: '',
      }],
}, 
      {
        title: "ZAVRŠNE ODREDBE",
        mandatory: false,
        statements: [
          {
            type: "text",
            mandatory: true,
            editable: true,
            content: `Ovaj Ugovor se primjenjuje od dana potpisivanja.\r\nNa sve odnose ugovornih strana u smislu međusobnih prava i obveza kojima mogu slobodno raspolagati, koje nisu određene ovim Ugovorom primjenjuju se opća načela obveznog prava. \r\nIzmjene i dopune ovog ugovora moraju biti u pisanom obliku.\r\nEventualne sporove nastale u vezi s Ugovorom, Poslodavac i Radnik pokušati će riješiti sporazumno, u protivnom, nadležan je stvarno nadležni sud prema sjedištu Poslodavca.`,
          }]
      },
      {
        title: 'PRIMJERCI UGOVORA',
        mandatory: false,
        statements: [
            {
                type: 'text',
                required: false,
                mandatory: true,
                editable: true,
                content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                value: '',
            }],
      },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
      {
        mandatory: true,
        static: true,
        type: 3,  // signatures
        statements: [],
      }
    ],
  
  };


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/225_ugovor_o_radu_direktora.ts